import { ThemeButton } from './ThemeWrapper';

const PHASES = [
  ['precheck', 'Precheck'],
  ['vnc', 'VNC stop'],
  ['processes', 'Process cleanup'],
  ['backup', 'Backup'],
  ['account', 'Account removal'],
  ['verify', 'Final verification'],
];

export function phaseForStep(step) {
  const value = String(step || '');
  if (['stop_vnc', 'disable_vnc', 'remove_vnc_users'].includes(value)) return 'vnc';
  if (value === 'stop_user_processes') return 'processes';
  if (value === 'home_backup') return 'backup';
  if (value === 'userdel') return 'account';
  if (['verify_local', 'home_data', 'remove_firewall', 'archive_cfg', 'local_groups', 'central_access', 'finished'].includes(value)) {
    return 'verify';
  }
  return 'precheck';
}

const OUTCOME_LABEL = {
  running: 'Running',
  finished: 'Completed',
  partial: 'Partially completed',
  failed: 'Failed',
  blocked: 'Blocked',
};

export function outcomeLabel(outcome) {
  return OUTCOME_LABEL[outcome] || '';
}

export default function LabJobProgress({ job, error, onRetry }) {
  if (!job && !error) return null;
  const phase = job?.phase || phaseForStep(job?.step);
  const phaseIndex = Math.max(0, PHASES.findIndex(([key]) => key === phase));
  const outcome = job?.outcome || (job?.status === 'running' ? 'running' : '');
  return (
    <div className="rounded-lg p-3 space-y-2" style={{ border: '1px solid var(--color-border)' }}>
      <p className="text-sm theme-text">
        {job?.action === 'delete' ? 'Delete' : 'Server action'} {job?.unixUsername || ''}
        {job?.jobId ? <span className="font-mono text-xs"> · {job.jobId}</span> : null}
        {outcome ? ` · ${outcomeLabel(outcome)}` : null}
      </p>
      <ol className="flex flex-wrap gap-2 text-xs">
        {PHASES.map(([key, label], index) => {
          const reached = index <= phaseIndex;
          return (
            <li key={key} style={{ fontWeight: key === phase ? 700 : 400, color: reached ? '#166534' : '#6b7280' }}>
              {index + 1}. {label}
            </li>
          );
        })}
      </ol>
      {job?.detail ? <p className="text-xs theme-text-secondary">{job.detail}</p> : null}
      <p className="text-xs theme-text-secondary">The home directory stays unless a separate home removal is approved.</p>
      {error ? (
        <div className="space-y-2">
          <p className="text-sm" style={{ color: '#b91c1c' }} role="alert">
            {error}
          </p>
          {job?.jobId && onRetry ? (
            <ThemeButton type="button" variant="secondary" onClick={onRetry}>
              Check progress again
            </ThemeButton>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
